import {
	EmailChangeAction,
	ChangeEmailError,
} from './change-email';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

const successMock: EmailChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_NO_CONTENT,
	});
};

const unauthorizedMock: EmailChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		error: ChangeEmailError.Unauthorized,
	});
};

const validationErrorMock: EmailChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		error: ChangeEmailError.EmailInvalid,
	});
};

const internalErrorMock: EmailChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
	});
};

export const changeEmailMocks: {
	success: EmailChangeAction;
	unauthorized: EmailChangeAction;
	validationError: EmailChangeAction;
	internalError: EmailChangeAction;
	fail: EmailChangeAction;
} = {
	success: successMock,
	unauthorized: unauthorizedMock,
	validationError: validationErrorMock,
	internalError: internalErrorMock,
	fail: internalErrorMock,
};
